@if (location()) {
  <div class="d-flex gap-4 align-items-center flex-wrap mb-4">
    <app-link-select [controlName]="'vehicle'"
                     [formGroup]="addVehicleFormGroup"
                     [id]="'vehicle'"
                     [label]="'VEHICLES.NAME'"
                     [optionLabelSelector]="[{selector: 'name'}]"
                     [searchService]="vehicleService"
                     [searchValueName]="'name'"
                     [queryParams]="availableVehicleQueryParams"
    ></app-link-select>
    <app-mdb-button (onClick)="addVehicle()"
                    [iconClass]="'fas fa-save'"
                    [loading]="loading"
                    [text]="'VEHICLES.ADD_VEHICLE'"></app-mdb-button>
  </div>

  <app-location-vehicles-table [location]="location()!"
                              (vehicleUnlinked)="refreshVehicles()"/>

}
